import { dateTimeToView } from "helpers/date";
import { emulatedLineStyle } from "helpers/map";
import React, { useState } from "react";
import { Polyline, Tooltip } from "react-leaflet";

const EmulatedSegments = React.memo((props) => {
    const { emulatedSegments } = props;
    const [hoveredLine, setHoveredLine] = useState();
    return emulatedSegments.map((item) => (
        <Polyline
            key={`${item.id}_${hoveredLine}`}
            positions={item.coordinates.map((item) => [...item].reverse())}
            {...emulatedLineStyle}
            eventHandlers={{
                mouseover: () => setHoveredLine(item.id),
                mouseout: () => setHoveredLine(undefined),
            }}
            color={hoveredLine === item.id ? "#a45300" : "#c16200"}
        >
            <Tooltip className="map__tooltip--default" direction="top">
                ID сегмента: {item.id}
                <br />
                {dateTimeToView(item.from)}&nbsp;&mdash;&nbsp;{dateTimeToView(item.to)}
            </Tooltip>
        </Polyline>
    ));
});

export default EmulatedSegments;
